import { Box, Button, Modal, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import useTranslation from "hooks/Translation";
import { Dispatch, SetStateAction } from "react";
import { generateResponsiveStyle } from "utils/modalStyle";

const LogoutModal = ({ open, setOpen, handleDelete }) => {
  const style = generateResponsiveStyle();
  const t = useTranslation();

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ textAlign: "center", fontSize: "19px" }}
        >
          {t.auth.logout}
        </Typography>
        <div className="flexdiv">
          <MDButton
            className="yesBtn"
            onClick={() => {
              setOpen(false);
              handleDelete();
            }}
          >
            {t.main.yes}
          </MDButton>

          <MDButton
            variant="outlined"
            color="error"
            onClick={() => setOpen(false)}
          >
            {t.main.no}
          </MDButton>
        </div>
      </Box>
    </Modal>
  );
};

export default LogoutModal;
